<template>
  <section class="leagues-camps-signup">
    <h1 class="title">Select a League (or Camp)</h1>
    <signup-list :season="season"></signup-list>
  </section>
</template>

<script>
// @ is an alias to /src
import SignupList from '@/components/SignupList.vue'

export default {
  name: 'Signup',
  computed: {
    season() {
      let seasons = [this.$store.state.currentSeason, this.$store.state.upcomingSeason];
      let id = this.$route.params.seasonId;
      return seasons.filter(season => season != null && season.id == id)[0];
    },
  },
  components: {
    SignupList,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1.title {
  margin-top: 1.5rem;
}
</style>